import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface NISProductDetailsCustomerPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const nisCustomerPartNumberStyles: NISProductDetailsCustomerPartNumberStyles = {
    labelText: {
        size: 16,
        css: css`
            margin-right: 4px;
            color: ${getProp("theme.typography.p.color")};
            font-family: Roboto;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: 16px;
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: 16px;
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: 16px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
            color: ${getProp("theme.typography.p.color")};
            font-weight: 400;
        `,
    },
};

const styles = nisCustomerPartNumberStyles;

const NISProductDetailsCustomerPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.customerProductNumber) {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="customerProductNumber">
            <Typography {...styles.labelText}>{translate("My Part #")}</Typography>
            {product.customerProductNumber}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(NISProductDetailsCustomerPartNumber),
    definition: {
        displayName: "NIS Customer Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
